export enum Role {
    User = 'User',
    Dentist = 'DENTIST',
    Manager = 'MANAGER',
    Printer = "PRINTER"
  }
